import type { AdminAccountPaymentDebugResponseActiveSubscription } from './adminAccountPaymentDebugResponseActiveSubscription';
import type { AdminAccountPaymentDebugResponseRecentOrdersItem } from './adminAccountPaymentDebugResponseRecentOrdersItem';
import type { AdminAccountPaymentDebugResponseRecentSubscriptionEventsItem } from './adminAccountPaymentDebugResponseRecentSubscriptionEventsItem';

export interface AdminAccountPaymentDebugResponse {
  /** @nullable */
  activeSubscription?: AdminAccountPaymentDebugResponseActiveSubscription;
  currentPlanCode: string;
  recentOrders: AdminAccountPaymentDebugResponseRecentOrdersItem[];
  recentSubscriptionEvents: AdminAccountPaymentDebugResponseRecentSubscriptionEventsItem[];
  userId: string;
}
